<template>
    <div class="">
        <Card class="w-11/12 mt-8 m-auto">
            <template #content>
                <table class="table-auto text-2xl">
                    <tbody>
                        <tr v-for="element in elements" :key="element.label" class="h-8">
                            <td class="text-left font-semibold w-5/12">{{ element.label }}</td>
                            <td class="text-left">{{ element.value }}</td>
                        </tr>
                    </tbody>
                </table>
                <Button rounded icon="pi pi-home" label="Return to Home" @click="returnHome" class="mt-1"></Button>
            </template>
        </Card>
    </div>
</template>

<script setup>
import UAParser from "ua-parser-js";
import { ROUTE_NAMES } from "@/src/router";

import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
const store = useStore();
const router = useRouter();

const loggedInUser = computed(() => store.getters["userStore/user"]);
const os = navigator?.userAgentData?.platform || navigator?.platform || "unknown";

const parser = new UAParser();
const browserVersion = parser.getResult().browser;

const elements = computed(() => {
    return [
        {
            label: "Service Image Tag:",
            value: import.meta.env.VITE_SERVICE_IMAGE_TAG,
        },
        {
            label: "Pac Image Tag:",
            value: import.meta.env.VITE_PAC_IMAGE_TAG,
        },
        {
            label: "Pac Logging Image Tag:",
            value: import.meta.env.VITE_PAC_LOGGING_IMAGE_TAG,
        },
        {
            label: "Service Deploy Timestamp:",
            value: import.meta.env.VITE_SERVICE_DEPLOY_TIMESTAMP,
        },
        {
            label: "Logged In User Email:",
            value: loggedInUser.value ? loggedInUser.value.email : "",
        },
        {
            label: "Logged In User Id:",
            value: loggedInUser.value ? loggedInUser.value.uid : "",
        },
        {
            label: "Browser Version:",
            value: `${browserVersion.name} ${browserVersion.version}`,
        },
        {
            label: "OS:",
            value: os,
        },
        {
            label: "Chatbot:",
            value: import.meta.env.VITE_APP_CHATBOT_ENABLED,
        },
        {
            label: "Data Model Trigger:",
            value: import.meta.env.VITE_APP_FEATURE_FLAG_DATA_MODEL_TRIGGER,
        },
    ];
});

const returnHome = () => router.push({ name: ROUTE_NAMES.HOME });
</script>

<style scoped>
/* Add your custom styles here */
</style>
